import { render, staticRenderFns } from "./amenities.vue?vue&type=template&id=bb3f7da6&scoped=true&"
import script from "./amenities.vue?vue&type=script&lang=js&"
export * from "./amenities.vue?vue&type=script&lang=js&"
import style0 from "./amenities.vue?vue&type=style&index=0&id=bb3f7da6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3f7da6",
  null
  
)

export default component.exports